<template>
  <div id="gatewayConfigurationSoftware" class="row">
    <div class="col-lg-5">
      <current-version :eui="eui" />
      <last-update :eui="eui" />
    </div>

    <div class="col-lg-7">
      <update :eui="eui" />
    </div>

    <div class="col-lg-12">
      <history :eui="eui" />
    </div>
  </div>
</template>

<script>
import CurrentVersion from './CurrentVersion'
import LastUpdate from './LastUpdate'
import Update from './Update'
import History from './History'

export default {
  titleKey: 'gatewayConfSoftware',

  components: { CurrentVersion, LastUpdate, Update, History },

  props: {
    eui: {
      type: String,
      default: ''
    }
  }
}
</script>
